import { render, staticRenderFns } from "./ManufacturingOrders.vue?vue&type=template&id=a8dcb9ce"
import script from "./ManufacturingOrders.vue?vue&type=script&lang=js"
export * from "./ManufacturingOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports